import { Component, ElementRef, EventEmitter, forwardRef, HostListener, Input, OnInit, Output, ViewChild } from "@angular/core";
import { TotalFeeResponse } from "../../../../objects/report/totalFeeResponse";
import { FeeTotal } from "../../../../objects/report/feeTotal";
import { AgentColorLink } from "../../../../objects/report/agentColorLink";
import { AgentSelectorComponent } from "../../filterSelectors/agentSelector/agentSelector.component";

/**
 * Created by alex.y on 9/20/2017.
 */
declare var $: any;

@Component({
    selector: "chart-total-fee",
    templateUrl: "./totalFeeChart.component.html",
    moduleId: module.id.toString()
})
export class TotalFeeChartComponent implements OnInit {
    @Input()
    public totalFeeResponses: Array<TotalFeeResponse> = [];

    @Input()
    public showCurrency: boolean = true;

    @Input()
    public showTotal: boolean = false;

    @Input()
    public showLegend: boolean = false;

    @Input()
    public agentColors: Array<AgentColorLink> = [];

    @Input()
    public agentSelectorComponent: AgentSelectorComponent;

    @ViewChild('chart') elementView: ElementRef;
    public parentHeight: number;


    /* Chart Settings Start */
    // lineChart
    public lineChartData: Array<any> = [];
    public lineChartLabels: Array<any> = [];
    public lineChartOptions: any;
    public lineChartColors: Array<any> = [];
    public lineChartLegend: boolean = true;
    public lineChartType: string = 'line';

    /* Chart Settings End*/

    public ngOnInit(): void {
        this.setChartData();
        this.generateColors();

        let max = this.getMax();

        let ticks = {
            beginAtZero: true,
            callback: (label: any) => {
                return this.formatNumber(label);
            }
        };

        if (max < 10) {
            ticks["min"] = 0;
            ticks["max"] = 10;
        }

        //this.convertAndCutDate();
        this.lineChartOptions = {
            responsive: true,
            legend: {
                display: this.showLegend,
                position: 'right',
                labels: {
                    usePointStyle: true
                },
            },
            scales: {
                yAxes: [{
                    ticks: ticks
                }]
            },
            tooltips: {
                callbacks: {
                    label: (tooltipItem: any) => {
                        return this.formatNumber(tooltipItem.yLabel);
                    },
                    title: (tooltipItem: any) => {
                        let email = this.lineChartData[tooltipItem[0].datasetIndex].label;
                        return `${tooltipItem[0].xLabel} : ${email}`;
                    }
                }
            }
        };
    }

    @HostListener("window:resize")
    public changeHeight(event: any): void {
        if (this.agentSelectorComponent)
            this.agentSelectorComponent.resizeSelect(this.elementView.nativeElement.offsetHeight);
    }

    private formatNumber(value: number): string {
        value = +value.toFixed(2);
        let parts = value.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return `${this.showCurrency ? 'CAD $' : ''}${parts.join(".")}`
    }

    private getMax(): number {
        let max = 0;

        for (let it of this.lineChartData) {
            for (let data of it.data) {
                if (data > max)
                    max = data;
            }
        }

        return max;
    }

    private setChartData(): void {
        let dates: Array<Date> = [];

        for (let resp of this.totalFeeResponses) {
            for (let it of resp.FeeTotals) {
                if (!dates.find(x => x.toString() == it.Date.toString()))
                    dates.push(it.Date);
            }
        }

        setTimeout(x => {
            if (this.agentSelectorComponent)
                this.agentSelectorComponent.resizeSelect(this.elementView.nativeElement.offsetHeight);
        }, 50);

        dates.sort((x, y) => {
            return new Date(x) >= new Date(y) ? 1 : -1;
        });

        for (let d of dates) {
            this.lineChartLabels.push(String.formatDateMMDDYYYY(d.toString()));
        }

        if (this.showTotal) {
            this.lineChartData.push({
                data: this.getTotal(this.totalFeeResponses, dates),
                label: "Total"
            });

            this.lineChartLabels = [];

            for (let d of dates) {
                this.lineChartLabels.push(String.formatDateDDMMMYYYY(d.toString()));
            }

            return;
        }

        for (let agent of this.totalFeeResponses) {
            var data = this.getData(agent.FeeTotals);

            this.lineChartData.push({
                data: data,
                label: agent.Agent.Email
            });
        }

        this.lineChartLabels = [];

        for (let d of dates) {
            this.lineChartLabels.push(String.formatDateDDMMMYYYY(d.toString()));
        }

    }

    private getTotal(arr: Array<TotalFeeResponse>, dates: Array<Date>): Array<number> {
        let itemValues = new Array<number>();

        for (let i = 0; i < this.lineChartLabels.length; i++) {
            itemValues.push(0);
        }

        for (let item of arr) {
            for (let fee of item.FeeTotals) {
                let index = this.lineChartLabels.indexOf(String.formatDateMMDDYYYY(fee.Date.toString()));
                itemValues[index] += fee.Total
            }
        }

        return itemValues;
    }


    private getData(totalFee: Array<FeeTotal>): Array<number> {
        let items = totalFee;

        let itemValues = new Array<number>();

        items.sort((x, y) => {
            return new Date(x.Date) >= new Date(y.Date) ? 1 : -1;
        });

        for (let i = 0; i < this.lineChartLabels.length; i++) {
            itemValues.push(0);
        }

        for (let it of items) {
            let index = this.lineChartLabels.indexOf(String.formatDateMMDDYYYY(it.Date.toString()));

            itemValues.splice(index, 1, it.Total);
        }

        return itemValues;
    }

    private generateColors(): void {
        for (let i = 1; i < this.lineChartData.length + 1; i++) {

            let colorObj = this.agentColors.find(x => x.Email == this.lineChartData[i - 1].label);

            let color = "#EB5757";

            if (colorObj)
                color = colorObj.color;

            this.lineChartColors.push({
                fill: false,
                backgroundColor: color,
                borderColor: color,
                pointBackgroundColor: color,
                pointBorderColor: `#fff`,
                pointHoverBackgroundColor: `#fff`,
                pointHoverBorderColor: color,
            })
        }
    }
}


// WEBPACK FOOTER //
// ./app/components/reports/charts/totalFeeChart/totalFeeChart.component.ts